<div class="dialog" data-testid="email-required-modal">
  <div class="title-container">
    <div class="title-left">
      <h3 class="title" data-testid="email-required-modal-title">{{ data.title | translate }}</h3>
    </div>
    <button class="close-btn" (click)="cancel()" mat-icon-button data-testid="email-required-modal-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="desc" data-testid="email-required-modal-message">{{ data.message | translate }}</div>
  <div class="input-wrapper">
    <input
      type="email"
      class="email-input"
      [formControl]="email"
      placeholder="{{ 'Email' | translate }}"
      data-testid="email-required-modal-input"
    />
    <div class="error-text" *ngIf="email.invalid && submitted" data-testid="email-required-modal-invalid">
      {{ 'InvalidEmail' | translate }}
    </div>
    <div class="error-text" *ngIf="errorMessage" data-testid="email-required-modal-error">
      {{ errorMessage | translate }}
    </div>
  </div>
  <div class="actions">
    <button
      class="def-button confirm-btn emphasized"
      [disabled]="saving"
      (click)="save()"
      data-testid="email-required-modal-save"
    >
      {{ data.confirmText | translate }}
    </button>
    <button
      class="def-button cancel-btn emphasized"
      [disabled]="saving"
      (click)="cancel()"
      data-testid="email-required-modal-cancel"
    >
      {{ data.cancelButton | translate }}
    </button>
  </div>
</div>
